import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CreditCardsService } from './credit-cards.service';
import { LoaderService } from './loader.service';

@Injectable({ providedIn: 'root' })
export class SelectPayResolver implements Resolve<any> {

  constructor(
    private creditCardsService: CreditCardsService,
    private loaderService: LoaderService
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const supplierId = +route.paramMap.get('supplierId');
    if (supplierId) {
      this.loaderService.increaseLoaderCount();
      return this.creditCardsService.fetchMapSupplierCreditCards(supplierId);
    } else {
      return null;
    }
  }
}
